import { useState } from "react";
import { Location } from "@components/ui/location_input.tsx";
import { router } from "@inertiajs/react";
import { SearchBar } from "@components/job_search/search_bar.tsx";

type Props = {
  granularLocationSearchEnabled: boolean;
};

const SearchSection = ({ granularLocationSearchEnabled }: Props) => {
  const [location, setLocation] = useState<Location | null>(null);
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSearch = () => {
    setLoading(true);

    router.get(
      "/jobs",
      {
        query: query || undefined,
        location: location?.display_name,
        lat: location?.latitude,
        lon: location?.longitude,
        location_type: location?.location_type || undefined,
        country_short_name: location?.country_short_name || undefined,
        state_short_name: location?.state_short_name || undefined,
      },
      {
        onFinish: () => setLoading(false),
      },
    );
  };

  return (
    <div className="welcome-search-bar-wrapper">
      {
        <SearchBar
          query={query}
          onQueryChange={setQuery}
          location={location}
          onLocationChange={setLocation}
          onSearch={handleSearch}
          disabled={loading}
          granularLocationSearchEnabled={granularLocationSearchEnabled}
        />
      }
    </div>
  );
};

export default SearchSection;
